import React from 'react';

import {
  Box,
  Stack,
  styled,
  Typography
} from '@mui/material';



const MainContainerBox = styled(Box)<{ background?: string }>(({ background }) => ({
  display: 'flex',
  alignItems: 'stretch',
  flexDirection: 'column',
  background
}));

const CenteredStack = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  textAlign: 'center',
  marginBottom: theme.spacing(8)
}));

const RoundPadBox = styled(Box)({
  width: 70,
  height: 70,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#C3D1D87F',
  borderRadius: 35
});



interface IProps {
  background?: string;
  step: string;
  title: string;
  subtitle: React.ReactNode;
  darkTheme?: boolean;

  children?: React.ReactNode | React.ReactNode[];
}

export const FC: React.FC<IProps> = props => {
  const textColor = props.darkTheme ? '#C3D1D8' : undefined;
  const roundPadBackgroundColor = props.darkTheme ? '#C3D1D8' : '#C3D1D87F';



  return (
    <MainContainerBox background={props.background}>
      <CenteredStack spacing={2}>
        <Stack
          alignItems='center'
          spacing={2}>
          <RoundPadBox sx={{ backgroundColor: roundPadBackgroundColor }}>
            <Typography variant="h1" color="#528898">{props.step}</Typography>
          </RoundPadBox>

          <Typography
            variant="h1"
            sx={{ color: textColor }}>
            {props.title}
          </Typography>

          <Box
            fontSize={18}
            sx={{ color: textColor }}>
            {props.subtitle}
          </Box>
        </Stack>
      </CenteredStack>

      <Box>
        {props.children}
      </Box>
    </MainContainerBox>
  );
};
